import { render, staticRenderFns } from "./radioaktivita-chart.vue?vue&type=template&id=0c081c75&"
import script from "./radioaktivita-chart.vue?vue&type=script&lang=js&"
export * from "./radioaktivita-chart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports